import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MechanicsApi } from "../../shared/sdk/services";
import moment from "moment";
import { regimenFiscal, usoCfdi } from "../catalogos-cfdi";
import { Router } from "@angular/router";

@Component({
  selector: "app-facturacion-linea",
  templateUrl: "./facturacion-linea.component.html",
  styleUrls: ["./facturacion-linea.component.scss"],
})
export class FacturacionLineaComponent implements OnInit {
  ticketForm: FormGroup;
  proformaForm: FormGroup;
  serverError;
  loading = false;
  ticket;
  regimenFiscal: any = regimenFiscal;
  usoCfdi: any = usoCfdi;
  displayedColumns: string[] = [
    "display_name",
    "qty",
    "price_unit",
    "discount",
    "price_subtotal",
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private mechanicsApi: MechanicsApi
  ) {
    this.ticketForm = this.fb.group({
      pos_reference: [
        null,
        [
          Validators.required,
          Validators.pattern("([0-9]){5}([-])([0-9]){3}([-])([0-9]){4}"),
        ],
      ],
      amount_total: [null, [Validators.required]],
    });
    this.proformaForm = this.fb.group({
      email: [null, [Validators.email]],
      rfc: [
        null,
        [
          Validators.required,
          Validators.pattern(
            "([A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A])|([A-Z&Ñ]{3}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A])|([A-Z&Ñ]{4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A])"
          ),
        ],
      ],
      cp: [null, [Validators.required]],
      razonSocial: [null, [Validators.required]],
      regimenFiscal: [null, [Validators.required]],
      usoCfdi: [null, [Validators.required]],
    });
  }

  ngOnInit() {}

  buscaTicket() {
    this.loading = true;
    this.serverError = null;
    this.ticket = null;
    this.mechanicsApi
      .buscaTicket(
        this.ticketForm.controls.pos_reference.value,
        this.ticketForm.controls.amount_total.value
      )
      .subscribe(
        (ticket) => {
          if (ticket.x_studio_facturador_estatus === "Timbrado") {
            this.router.navigate([
              "/descargasPdfXml/" + ticket.x_studio_facturador_uuid,
            ]);
          } else if (ticket.serverError) {
            this.serverError = ticket.serverError;
          } else {
            this.serverError = null;
            if (ticket.partner_id) {
              if (ticket.cliente) {
                this.proformaForm.controls.email.setValue(
                  String(ticket.cliente.email).toLowerCase()
                );
                this.proformaForm.controls.rfc.setValue(
                  String(ticket.cliente.vat).toUpperCase()
                );
                this.proformaForm.controls.razonSocial.setValue(
                  String(ticket.cliente.name).toUpperCase()
                );
                this.proformaForm.controls.cp.setValue(ticket.cliente.zip);
                this.proformaForm.controls.regimenFiscal.setValue(
                  ticket.cliente.l10n_mx_edi_fiscal_regime
                );
              }
            }
            this.ticket = ticket;
          }
          this.loading = false;
        },
        (err) => {
          this.serverError = err;
          this.loading = false;
        }
      );
  }

  obtenRangoFecha(fecha) {
    const hoy = moment();
    const ultimoMes = moment(fecha).subtract(6, "hours").endOf("month");
    return hoy.isAfter(ultimoMes);
  }

  creaFactura() {
    this.loading = true;
    this.ticket.cliente.name = this.proformaForm.controls.razonSocial.value;
    this.ticket.cliente.email = this.proformaForm.controls.email.value;
    this.ticket.cliente.vat = this.proformaForm.controls.rfc.value;
    this.ticket.cliente.usoCfdi = this.proformaForm.controls.usoCfdi.value;
    this.ticket.cliente.cp = this.proformaForm.controls.cp.value;
    this.ticket.cliente.regimenFiscal =
      this.proformaForm.controls.regimenFiscal.value;
    this.mechanicsApi.creaFactura(this.ticket).subscribe(
      (cfdi) => {
        if (!cfdi.uuid) {
          this.serverError = cfdi;
          this.loading = false;
        } else {
          this.router.navigate(["/descargasPdfXml/" + cfdi.uuid]);
        }
      },
      (err) => {
        console.log(err);
        this.serverError = err;
        this.loading = false;
      }
    );
  }
}
